/**
 * Observability system public API.
 * 
 * This module exports the main entry point for the observability system.
 * Components should use ObservabilityController for all tracking needs,
 * similar to how they use AnalyticsController.
 */

export { ObservabilityController } from './observability-controller';
export { getObservabilityConfig } from './config';
export type { ObservabilityProvider, StandardEventAttributes } from './providers/types';
export type { ObservabilityConfig, ObservabilityProviderType } from './config';

